import React from "react";
import DividerBlock from "../../../divider-block";
import FieldBlock from '../../../field-block';
import { DatePicker, TimePicker } from "antd";
import { Col, Row } from "antd";
import localeDatePicker from 'antd/lib/date-picker/locale/ru_RU';
import moment from "moment";
import { Button, Checkbox } from "antd";
import InputField from "../../../input-field";
import { uuidHelper } from "../../../../helpers/uuid.helper";
import TextArea from "antd/lib/input/TextArea";
import { useState } from "react";
import SelectField from "../../../select-field";
import NumberInputField from "../../../number-input-field";
import { useEffect } from "react";

const { RangePicker } = DatePicker;

export class Equipment {
  #translatedCarcassTypes;

  constructor(number, translatedCarcassTypes) {
    this.number = number;
    this.points = [];
    this.uuid = uuidHelper.generateUUID();
    this.type = '';
    this.weight = '';
    this.volume = '';
    this.#translatedCarcassTypes = translatedCarcassTypes;
  }

  get Id() {
    return this.uuid;
  }

  get Name() {
    return this.number + '. ' + this.getTypeName() + ' ' + this.weight + 'кг';
  }

  getTypeName() {
    const equipmentType = this.#translatedCarcassTypes.find(t => t.id === this.type);
    return equipmentType ? equipmentType.title : 'Неизвестный тип';
  }
}

export default function Equipments({
  pointUuid,
  equipments,
  setEquipments,
  pointEquipments,
  setPointEquipments,
  fieldsErrors,
  dividerStyle,
  translatedCarcassTypes}
) {

  const transportationTypesList = [
    {Id: 'containers', Name: 'Контейнеры'},
    {Id: 'trucks', Name: 'Фуры'},
  ];

  const [transportationType, setTransportationType] = useState(null);
  const [activeTransportationTypesList, setActiveTransportationTypesList] = useState([]);

  let bigButtonStyle = { width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px', borderColor: 'transparent', boxShadow: 'none' };

  const getEquipmentErrors = (nameField, key) => {
    return (fieldsErrors && typeof fieldsErrors['equipment.'+nameField+'.'+key] !== "undefined")
      ? fieldsErrors['equipment.'+nameField+'.'+key][0]
      : null;
  };

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField][0]
      : null;
  };

  const addEquipment = () => {
    if (equipments.length < 10) {
        const newEquipments = [...equipments];

        let maxNumber = 1;
        if(newEquipments.length > 0) {
          maxNumber = Math.max(...equipments.map(o => o.number));
          maxNumber++;
        }

        newEquipments.push(new Equipment(maxNumber, translatedCarcassTypes));
        setEquipments(newEquipments);
    }
};

  const renderEquipments = (equipments, setEquipments) => {
    const removeEquipment = (uuid) => {
      equipments.forEach((e, i) => {
          if (i > 0) {
              if (e.uuid === uuid) {
                  const newEquipments = [...equipments];
                  newEquipments.splice(i, 1);
                  setEquipments(newEquipments);
              }
          }
      })
      let newPointEquipments = {...pointEquipments}
      Object.keys(newPointEquipments).forEach((p) => {
        delete newPointEquipments[p][uuid];
      })
      setPointEquipments(newPointEquipments);
    };

    const updateEquipment = (key, value, uuid) => {
      const newEquipments = [...equipments];
      newEquipments.forEach((e, i) => {
          if (e.uuid === uuid) {
            newEquipments[i][key] = value;
            setEquipments(newEquipments);
          }
      });
    };

    useEffect(() => {
      let equipmentsPoints = {};
      Object.keys(pointEquipments).forEach((p) => {
        Object.keys(pointEquipments[p]).forEach((c) => {
          if(!equipmentsPoints[c]) {
            equipmentsPoints[c] = [];
          }
          equipmentsPoints[c].push({'guid': p, 'weight': pointEquipments[p][c]});
        });
      });

      equipments.forEach((c) => {
        updateEquipment('points', equipmentsPoints[c.uuid] || [], c.uuid);
      });
    },[pointEquipments])

    useEffect(() => {
      if(transportationType) {
        const isContainer = (transportationType == 'containers' ? 1 : 0);
        let newTypes = [];
        newTypes = translatedCarcassTypes.filter((itemType) => {
          return itemType.isContainer == isContainer;
        });
        setActiveTransportationTypesList(newTypes);
        setEquipments([]);
        setPointEquipments([]);
      }
    }, [transportationType]);

    return equipments.map((cont, i) => (
      (cont.point === pointUuid) &&
      <div style={{ border: '1px solid rgba(0, 0, 0, 0.1)', marginTop: '10px', padding: '15px' }} key={`cont-${i}`}>
        <Row gutter={[16, 24]} key={i + 1} >
          <Col lg={2} md={24} sm={24} sx={24}>
            <p>{cont.number}.</p>
          </Col>
          <Col lg={9} md={24} sm={24} sx={24}>
            <SelectField
              title="Тип"
              name="type"
              selectedValue={cont.type}
              values={activeTransportationTypesList}
              keyNum={cont.uuid}
              onChange={value => {
                updateEquipment('type', value, cont.uuid);
              }}
              getErrors={getEquipmentErrors}
              style={{ width: "100%" }}
            />
          </Col>
          <Col lg={transportationType == 'trucks' ? 5 : 10} md={24} sm={24} sx={24}>
              <NumberInputField
                  name="weight" label="Вес (кг)"
                  value={cont.weight} setValue={value => updateEquipment('weight', value, cont.uuid)}
                  keyNum={cont.uuid}
                  getFieldErrors={getEquipmentErrors}
              />
          </Col>
          {transportationType == 'trucks' &&
          <Col lg={5} md={24} sm={24} sx={24}>
              <NumberInputField
                  name="volume" label="Объём (м³)"
                  value={cont.volume} setValue={value => updateEquipment('volume', value, cont.uuid)}
                  keyNum={cont.uuid}
                  getFieldErrors={getEquipmentErrors}
              />
          </Col>}
          <Col lg={3} md={24} sm={24} sx={24}>
            <Button
                type="danger"
                icon="close"
                onClick={() => removeEquipment(cont.uuid)}
                style={{ ...bigButtonStyle, backgroundColor: 'red', color: 'white', float: 'right', width: '50px' }}
            />
          </Col>
        </Row>
      </div >
    ));
  }

    return (
      <>
        <span className="divider-label">Транспорт</span>
        <DividerBlock style={dividerStyle}/>
        <Row gutter={[16, 24]}>
          <Col lg={24} md={24} sm={24} sx={24}>
            <SelectField
              title="Тип доставки"
              name="transportationType"
              selectedValue={transportationType}
              values={transportationTypesList}
              onChange={value => {
                setTransportationType(value);
              }}
              getErrors={getEquipmentErrors}
              style={{ width: "100%" }}
            />
          </Col>
      </Row>
      {renderEquipments(equipments, setEquipments)}
      <Row gutter={[16, 24]} style={{ marginBottom: '60px' }}>
          <Col lg={24} md={24} sm={24} sx={24} style={{ textAlign: 'center' }}>
            <FieldBlock name={"equipments"} getErrors={getFieldErrors}>
              <Button type="primary" size="small" htmlType="button" disabled={!transportationType} onClick={addEquipment} style={{ ...bigButtonStyle }}>Добавить</Button>
            </FieldBlock>
          </Col>
      </Row>
      <DividerBlock style={dividerStyle} />
      </>
    );
}